import { Field } from "../../field";
import { FieldSet } from "../../fieldset";
import { Merchant } from "../../merchant";
import { CountryList, MerchantField } from "../../types";
import { SubIndustry } from "../../types/subIndustry";

type CountryListSubIndustryMap = {
  [key in CountryList]: SubIndustry[];
};
/**
 * AU / NZ & US / CA are the same. Consider extracting? Premature optimization?
 * What happens if they deviate? Obv we could spread common, but is
 * this desirable?
 */
export const countryListSubIndustryMap: CountryListSubIndustryMap = {
  Australia: [
    "General Practice",
    "Dental Services",
    "Optometry",
    "Pharmaceutical Retailing",
    "Other",
  ],
  Canada: [],
  "New Zealand": [
    "General Practice",
    "Dental Services",
    "Optometry",
    "Pharmaceutical Retailing",
    "Other",
  ],
  "United Kingdom": [],
  "United States": [],
};

export class SubIndustryField extends Field<SubIndustry> {
  constructor(
    model: Merchant,
    fieldSet: FieldSet<any>,
    opts: Partial<MerchantField<SubIndustry>> = {}
  ) {
    super(
      model,
      {
        dataType: "string",
        propertyName: "subIndustry",
        uiFieldType: "Select",
        ...opts,
      },
      fieldSet
    );
  }

  get applicable(): boolean {
    const industry = this._model.storeDetails.industry.value;
    const registeredCountry = this._model.companyInformation.registeredCountry
      .value;
    if (
      (registeredCountry === "Australia" ||
        registeredCountry === "New Zealand") &&
      industry === "Health"
    ) {
      return true;
    }
    return false;
  }

  get testValue(): any {
    const registeredCountry = this._model.companyInformation.registeredCountry
      .value;

    return registeredCountry
      ? countryListSubIndustryMap[registeredCountry][0]
      : "General Practice";
  }

  get pickList(): SubIndustry[] {
    const registeredCountry = this._model.companyInformation.registeredCountry
      .value;

    return registeredCountry
      ? countryListSubIndustryMap[registeredCountry]
      : [];
  }

  get required(): boolean {
    return this.applicable;
  }

  get shown(): boolean {
    return this.applicable;
  }
}
